import { omit } from 'lodash-es'
import { useFormContext, useWatch } from 'react-hook-form'
import { useDeepCompareEffect } from 'use-deep-compare'

import { FormConfig } from '../../../state/configuration'
import { isInputConfig } from '../config'

const toValidationTriggers = (config: FormConfig): string[] =>
  config.filter(isInputConfig).flatMap((input) => {
    const otherRules = omit(input.validation ?? {}, '_self')
    return Object.keys(otherRules)
  })

export const useValidationTriggers = (config: FormConfig) => {
  const {
    control,
    trigger,
    formState: { isValidating },
  } = useFormContext()

  const triggers = toValidationTriggers(config)

  const values = useWatch({
    control,
    name: triggers,
  })

  useDeepCompareEffect(() => {
    if (isValidating) {
      void trigger()
    }
  }, values)
}
